import React from 'react';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { NotificationManager } from 'react-notifications';

import UserRoles from "../../../../../common/src/enums/UserRoles";
import { currentWeek } from "../../../../../common/src/util/lib";
import { ROUTE_ERROR_LISTS } from '../../../constants/routeconstants';
import * as AdminActions from "../../../actions/admin";

import {confirm} from "../../../utils/confirmDialog";

import UserFieldDataType from "../../../utils/enums/UserFieldDataTypeEnum";
import UserFieldElement from "../../reusable/UserFieldElement";

import Signups from "./subPages/Signups";
import Watches from "./subPages/Watches";
import Membergames from "./subPages/Membergames";
import Financials from "./subPages/Financials";
import Submissions from "./subPages/Submissions";
import Pigeons from "./subPages/Pigeons";
import Rings from "./subPages/Rings";
import DM from "./subPages/DM";
import Status from "./subPages/Status";

class ErrorListsPage extends React.Component {

    static getId() {
        return ROUTE_ERROR_LISTS;
    }

    static getAllowedRoles() {
        return [UserRoles.MAIN_ADMIN, UserRoles.SECTION_ADMIN]; // empty means allowed for all
    }

    constructor(props) {
        super(props);
        const week = currentWeek();
        this.state = {
            week: props.params.subpage === 'pigeons' || props.params.subpage === 'rings' || props.params.subpage === 'dm' ? 'blank' : String(week),
            selectedWeek: String(week),
            club: props.params.subpage === 'pigeons' || props.params.subpage === 'rings' || props.params.subpage === 'dm' || props.params.subpage === 'status' ? 'all' : 'blank',
            selectedClub: 'blank',
            editMode: false,
        }
    }

    componentDidMount() {
        this.props.dispatch(AdminActions.getClubs());
        this.loadErrorList(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.params.subpage !== this.props.params.subpage) {
            this.setState({
                week: nextProps.params.subpage === 'pigeons' || nextProps.params.subpage === 'rings' || nextProps.params.subpage === 'dm' ? 'blank' : this.state.selectedWeek,
                club: this.state.selectedClub === 'blank' && (nextProps.params.subpage === 'pigeons' || nextProps.params.subpage === 'rings' || nextProps.params.subpage === 'dm' || nextProps.params.subpage === 'status') ? 'all' : this.state.selectedClub,
            }, () => this.loadErrorList(nextProps));
        }
    }

    loadErrorList = newestProps => {
        newestProps.dispatch(AdminActions.getErrorListItems(newestProps.params.subpage, this.state.week, this.state.club));
    };

    subForm = null;
    render() {

        const showRow = (week, club) =>
            (this.state.week === 'all' || (this.state.week === 'blank' && (week === null || week === '')) || this.state.week === week) &&
            (this.state.club === 'all' || (this.state.club === 'blank' && (club === null || club === '')) || this.state.club === club);

        // Skip until ready.
        if (!this.props.admin.isClubsRead) return null;

        let subPage = null;
        switch (this.props.params.subpage) {
            case 'signups':
                subPage = <Signups data={this.props.admin.errorLists.signups.filter(row => showRow(row.Uge, row.Forening)).sort((row1, row2) => {
                        if (Number(row1.Uge) < Number(row2.Uge)) return -1;
                        if (Number(row1.Uge) > Number(row2.Uge)) return 1;
                        if (row1.Forening < row2.Forening) return -1;
                        if (row1.Forening > row2.Forening) return 1;
                        if (row1.KFK < row2.KFK) return -1;
                        if (row1.KFK > row2.KFK) return 1;
                        if (row1.Slag < row2.Slag) return -1;
                        if (row1.Slag > row2.Slag) return 1;
                        if (row1.Ringnummer < row2.Ringnummer) return -1;
                        if (row1.Ringnummer > row2.Ringnummer) return 1;
                        return 0;
                    }).toArray()}
                    setEditMode={this.setEditMode} updateRow={this.updateRow} deleteRow={this.deleteRow} acceptRow={this.acceptRow}
                    ref={instance => { this.subForm = instance; }}
                />;
                break;
            case 'watches':
                subPage = <Watches data={this.props.admin.errorLists.watches.filter(row => showRow(row.Ugenr, row.Foreningsnr)).sort((row1, row2) => {
                        if (Number(row1.Ugenr) < Number(row2.Ugenr)) return -1;
                        if (Number(row1.Ugenr) > Number(row2.Ugenr)) return 1;
                        if (row1.Foreningsnr < row2.Foreningsnr) return -1;
                        if (row1.Foreningsnr > row2.Foreningsnr) return 1;
                        if (row1.Slagnr < row2.Slagnr) return -1;
                        if (row1.Slagnr > row2.Slagnr) return 1;
                        if (row1.Urnr < row2.Urnr) return -1;
                        if (row1.Urnr > row2.Urnr) return 1;
                        return 0;
                    }).toArray()}
                   setEditMode={this.setEditMode} updateRow={this.updateRow} deleteRow={this.deleteRow} acceptRow={this.acceptRow}
                   ref={instance => { this.subForm = instance; }}
                />;
                break;
            case 'membergames':
                subPage = <Membergames data={this.props.admin.errorLists.membergames.filter(row => showRow(row.Uge, row.Foreningsnr)).sort((row1, row2) => {
                        if (Number(row1.Uge) < Number(row2.Uge)) return -1;
                        if (Number(row1.Uge) > Number(row2.Uge)) return 1;
                        if (row1.Foreningsnr < row2.Foreningsnr) return -1;
                        if (row1.Foreningsnr > row2.Foreningsnr) return 1;
                        if (row1.Slag < row2.Slag) return -1;
                        if (row1.Slag > row2.Slag) return 1;
                        if (row1.KFK < row2.KFK) return -1;
                        if (row1.KFK > row2.KFK) return 1;
                        return 0;
                    }).toArray()}
                    setEditMode={this.setEditMode} updateRow={this.updateRow} deleteRow={this.deleteRow} acceptRow={this.acceptRow}
                    ref={instance => { this.subForm = instance; }}
                />;
                break;
            case 'financials':
                subPage = <Financials data={this.props.admin.errorLists.financials.filter(row => showRow(row.Uge, row.Foreningsnr)).sort((row1, row2) => {
                        if (Number(row1.Uge) < Number(row2.Uge)) return -1;
                        if (Number(row1.Uge) > Number(row2.Uge)) return 1;
                        if (row1.Foreningsnr < row2.Foreningsnr) return -1;
                        if (row1.Foreningsnr > row2.Foreningsnr) return 1;
                        if (row1.Sektion < row2.Sektion) return -1;
                        if (row1.Sektion > row2.Sektion) return 1;
                        if (row1.KFK < row2.KFK) return -1;
                        if (row1.KFK > row2.KFK) return 1;
                        return 0;
                    }).toArray()}
                    setEditMode={this.setEditMode} updateRow={this.updateRow} deleteRow={this.deleteRow} acceptRow={this.acceptRow}
                    ref={instance => { this.subForm = instance; }}
                />;
                break;
            case 'submissions':
                subPage = <Submissions data={this.props.admin.errorLists.submissions.filter(row => showRow(row.Uge, row.Foreningsnr)).sort((row1, row2) => {
                        if (Number(row1.Uge) < Number(row2.Uge)) return -1;
                        if (Number(row1.Uge) > Number(row2.Uge)) return 1;
                        if (row1.Foreningsnr < row2.Foreningsnr) return -1;
                        if (row1.Foreningsnr > row2.Foreningsnr) return 1;
                        if (row1.KFK < row2.KFK) return -1;
                        if (row1.KFK > row2.KFK) return 1;
                        if (row1.Slagnr < row2.Slagnr) return -1;
                        if (row1.Slagnr > row2.Slagnr) return 1;
                        if (row1.Indleveret < row2.Indleveret) return -1;
                        if (row1.Indleveret > row2.Indleveret) return 1;
                        return 0;
                    }).toArray()}
                    deleteRow={this.deleteRow}
                    ref={instance => { this.subForm = instance; }}
                />;
                break;
            case 'pigeons':
                subPage = <Pigeons data={this.props.admin.errorLists.pigeons.filter(row => showRow(null, row.Foreningsnr)).sort((row1, row2) => {
                        if (row1.Foreningsnr < row2.Foreningsnr) return -1;
                        if (row1.Foreningsnr > row2.Foreningsnr) return 1;
                        if (row1.Slagnr < row2.Slagnr) return -1;
                        if (row1.Slagnr > row2.Slagnr) return 1;
                        if (row1.Ringnummer < row2.Ringnummer) return -1;
                        if (row1.Ringnummer > row2.Ringnummer) return 1;
                        return 0;
                    }).toArray()}
                    setEditMode={this.setEditMode} updateRow={this.updateRow} deleteRow={this.deleteRow} acceptRow={this.acceptRow}
                    ref={instance => { this.subForm = instance; }}
                />;
                break;
            case "rings":
                subPage = <Rings data={this.props.admin.errorLists.rings.filter(row => showRow(null, row.Foreningsnr)).sort((row1, row2) => {
                        if (row1.Foreningsnr < row2.Foreningsnr) return -1;
                        if (row1.Foreningsnr > row2.Foreningsnr) return 1;
                        if (row1.Slagnr < row2.Slagnr) return -1;
                        if (row1.Slagnr > row2.Slagnr) return 1;
                        if (row1.Aar < row2.Aar) return -1;
                        if (row1.Aar > row2.Aar) return 1;
                        if (row1.Fra < row2.Fra) return -1;
                        if (row1.Fra > row2.Fra) return 1;
                        if (row1.Til < row2.Til) return -1;
                        if (row1.Til > row2.Til) return 1;
                        return 0;
                    }).toArray()}
                    setEditMode={this.setEditMode} updateRow={this.updateRow} deleteRow={this.deleteRow} acceptRow={this.acceptRow}
                    ref={instance => { this.subForm = instance; }}
                />;
                break;
            case 'dm':
                subPage = <DM data={this.props.admin.errorLists.dm.filter(row => showRow(null, row.Foreningsnr)).sort((row1, row2) => {
                        if (row1.Foreningsnr < row2.Foreningsnr) return -1;
                        if (row1.Foreningsnr > row2.Foreningsnr) return 1;
                        if (row1.Slag < row2.Slag) return -1;
                        if (row1.Slag > row2.Slag) return 1;
                        if (Number(row1.Uge) < Number(row2.Uge)) return -1;
                        if (Number(row1.Uge) > Number(row2.Uge)) return 1;
                        if (row1.KFK < row2.KFK) return -1;
                        if (row1.KFK > row2.KFK) return 1;
                        return 0;
                    }).toArray()}
                    setEditMode={this.setEditMode} updateRow={this.updateRow} deleteRow={this.deleteRow} acceptRow={this.acceptRow}
                    ref={instance => { this.subForm = instance; }}
                />;
                break;
            case 'status':
                const hasWeeks = this.props.admin.errorLists.status.toArray().findIndex(status => status.Uge !== '0') >= 0;
                subPage = <Status data={this.props.admin.errorLists.status.filter(status =>
                    (((this.state.week === 'all' && (!hasWeeks || status.Uge !== ''))) || (this.state.week === 'blank' && status.Uge === '') || (this.state.week !== 'all' && this.state.week !== 'blank' && this.state.week === status.Uge)) &&
                    (this.state.club === 'all' || (this.state.club !== 'blank' && this.state.club === status.Foreningsnr))).sort((row1, row2) => {
                    if (row1.Foreningsnr < row2.Foreningsnr) return -1;
                    if (row1.Foreningsnr > row2.Foreningsnr) return 1;
                    if (Number(row1.Uge) < Number(row2.Uge)) return -1;
                    if (Number(row1.Uge) > Number(row2.Uge)) return 1;
                    return 0;
                }).toArray()}
                    ref={instance => { this.subForm = instance; }}
                />;
                break;
        }
        const editMode = this.state.editMode;

        const clubList = this.props.admin.clubs.filter(c =>
            (this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id && c.Sektionsnr !== '99') ||
            (this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id && c.Sektionsnr === this.props.auth.currentEntity)
        ).sort((c1, c2) => c1.Foreningsnr < c2.Foreningsnr ? -1 : 1).map(club => ({key: club.Foreningsnr, value: club.Foreningsnr + ' ' + club.Navn})).toArray();
        clubList.unshift({key: 'all', value: 'Alle'});
        clubList.unshift({key: 'blank', value: 'Ingen'});

        const weekList = [...Array(53).keys()].map(wk => ({key: String(wk + 1), value: String(wk + 1)}));
        weekList.unshift({key: 'all', value: 'Alle'});
        weekList.unshift({key: 'blank', value: 'Ukendt'});

        return (<div>
            <div className="sub-page-title">
                <h2>Fejllister</h2>
            </div>
            <div className="sub-page-content">
                <div className="tab-list">
                    <Link className={(this.props.params.subpage === 'signups' ? "tab-link active" : "tab-link") + (editMode ? ' disabled' : '')} to={editMode ? '' : ROUTE_ERROR_LISTS.replace(":subpage", "signups")}>
                        <span className="tab-text">Tilmeld</span>
                    </Link>
                    <Link className={(this.props.params.subpage === 'watches' ? "tab-link active" : "tab-link") + (editMode ? ' disabled' : '')} to={editMode ? '' : ROUTE_ERROR_LISTS.replace(":subpage", "watches")}>
                        <span className="tab-text">Ure</span>
                    </Link>
                    <Link className={(this.props.params.subpage === 'membergames' ? "tab-link active" : "tab-link") + (editMode ? ' disabled' : '')} to={editMode ? '' : ROUTE_ERROR_LISTS.replace(":subpage", "membergames")}>
                        <span className="tab-text">Slagspil</span>
                    </Link>
                    <Link className={(this.props.params.subpage === 'financials' ? "tab-link active" : "tab-link") + (editMode ? ' disabled' : '')} to={editMode ? '' : ROUTE_ERROR_LISTS.replace(":subpage", "financials")}>
                        <span className="tab-text">Regnskab</span>
                    </Link>
                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <Link className={(this.props.params.subpage === 'submissions' ? "tab-link active" : "tab-link") + (editMode ? ' disabled' : '')} to={editMode ? '' : ROUTE_ERROR_LISTS.replace(":subpage", "submissions")}>
                        <span className="tab-text">Indlevering</span>
                    </Link> : null}
                    {/*<Link className={(this.props.params.subpage === 'pigeons' ? "tab-link active" : "tab-link") + (editMode ? ' disabled' : '')} to={editMode ? '' : ROUTE_ERROR_LISTS.replace(":subpage", "pigeons")}>
                        <span className="tab-text">Duer</span>
                    </Link>
                    <Link className={(this.props.params.subpage === 'rings' ? "tab-link active" : "tab-link") + (editMode ? ' disabled' : '')} to={editMode ? '' : ROUTE_ERROR_LISTS.replace(":subpage", "rings")}>
                        <span className="tab-text">Ringserier</span>
                    </Link>
                    <Link className={(this.props.params.subpage === 'dm' ? "tab-link active" : "tab-link") + (editMode ? ' disabled' : '')} to={editMode ? '' : ROUTE_ERROR_LISTS.replace(":subpage", "dm")}>
                        <span className="tab-text">DM</span>
                    </Link>*/}
                    <Link className={(this.props.params.subpage === 'status' ? "tab-link active" : "tab-link") + (editMode ? ' disabled' : '')} to={editMode ? '' : ROUTE_ERROR_LISTS.replace(":subpage", "status")}>
                        <span className="tab-text">Status</span>
                    </Link>
                </div>
                <div className="tab-page">
                    {subPage}
                </div>
            </div>
            <div className="sub-page-actions">
                <span className="left-buttons" key="left">
                    <span><label htmlFor="week" disabled={editMode}>Uge</label></span>
                    <span>
                        <UserFieldElement dataType={UserFieldDataType.enum} placeholder={'false'} className="field100" containerClassName="display-inline-block"
                                          name="week" id="week" value={this.state.week} options={weekList} disabled={editMode}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={e => {
                                              this.setState({
                                                  week: e.target.value,
                                                  selectedWeek: e.target.value,
                                              }, () => this.loadErrorList(this.props));
                                          }}
                        />
                    </span>
                    <span><label htmlFor="club" disabled={editMode}>Forening</label></span>
                    <span>
                        <UserFieldElement dataType={UserFieldDataType.enum} placeholder={'false'} className="field250" containerClassName="display-inline-block"
                                          name="club" id="club"  value={this.state.club} options={clubList} disabled={editMode}
                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                          onChange={e => {
                                              this.setState({
                                                  club: e.target.value,
                                                  selectedClub: e.target.value,
                                              }, () => this.loadErrorList(this.props));
                                          }}
                        />
                    </span>
                </span>
                <span className="right-buttons" key="right">
                    <button className="btn-primary" title="Accepter alle viste rækker" disabled={
                        editMode || this.props.params.subpage === 'submissions' || this.props.params.subpage === 'status' || (
                            this.props.auth.currentRole !== UserRoles.MAIN_ADMIN.id && this.props.params.subpage !== 'signups' && this.props.params.subpage !== 'membergames' && this.props.params.subpage !== 'financials'
                        )
                    } onClick = {() => {
                        if (!editMode && this.props.params.subpage !== 'status' && (
                            this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || this.props.params.subpage === 'signups' || this.props.params.subpage === 'membergames' || this.props.params.subpage === 'financials'
                        )) {
                            const keys = this.subForm.getWrappedInstance().getAllKeys();
                            if (keys.length > 0) confirm("Accepter alle rækker", <span>Ønsker du at acceptere alle viste rækker?</span>, () => {
                                this.props.dispatch(AdminActions.acceptErrorListItem(this.props.params.subpage, keys, response => {
                                    if (response.accepted.length > 0) NotificationManager.success(String(response.accepted.length) + " række" + (response.accepted.length > 1 ? 'r' : '') + " blev accepteret.", "Accept", 4000);
                                    if (response.failed.length > 0) NotificationManager.warning(String(response.failed.length) + " række" + (response.failed.length > 1 ? 'r' : '') + " kunne ikke accepteres jfr. nye fejlbeskeder." + (response.accepted.length === 0 ? " Ingen rækker blev accepteret." : ""), "Fejl", 0);
                                }));
                            });
                        }
                    }}>Accepter alle</button>
                    <button className="btn-secondary" title="Slet alle viste rækker" disabled={
                        editMode || this.props.params.subpage === 'status' || (
                            this.props.auth.currentRole !== UserRoles.MAIN_ADMIN.id && this.props.params.subpage !== 'signups' && this.props.params.subpage !== 'membergames' && this.props.params.subpage !== 'financials'
                        )
                    } onClick = {() => {
                        if (!editMode && this.props.params.subpage !== 'status' && (
                            this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id || this.props.params.subpage === 'signups' || this.props.params.subpage === 'membergames' || this.props.params.subpage === 'financials'
                        )) {
                            const keys = this.subForm.getWrappedInstance().getAllKeys();
                            if (keys.length > 0) confirm("Slet alle rækker", <span>Ønsker du at slette alle viste rækker?</span>, () => {
                                this.props.dispatch(AdminActions.deleteErrorListItem(this.props.params.subpage, keys, response => {
                                    NotificationManager.success(String(response.deleted.length) + " række" + (response.deleted.length > 1 ? 'r' : '') + " blev slettet.", "Sletning", 4000);
                                }));
                            });
                        }
                    }}>Slet alle</button>
                </span>
            </div>
        </div>);
    }

    setEditMode = mode => this.setState({editMode: mode});

    updateRow = (key, updates, onSuccess) => this.props.dispatch(AdminActions.updateErrorListItem(this.props.params.subpage, key, updates, onSuccess));

    deleteRow = (key, onSuccess) => this.props.dispatch(AdminActions.deleteErrorListItem(this.props.params.subpage, key, onSuccess));

    acceptRow = (key, onSuccess) => this.props.dispatch(AdminActions.acceptErrorListItem(this.props.params.subpage, key, onSuccess));
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        errorLists: state.admin.errorLists,
        isClubsRead: state.admin.isClubsRead,
        clubs: state.admin.clubs,
    }
});

export default connect(mapStateToProps)(ErrorListsPage);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/errorLists/ErrorListsPage.js